// biome-ignore-all lint/suspicious/noArrayIndexKey: using index as key for dynamic list

import { ErrorMessage, Field, FieldArray, Form, Formik } from "formik";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { Button, Col, FormGroup, Row, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { getAllRulesAsync } from "../../Helpers/API/RuleApi";
import RulesSelect from "../../Helpers/SelectValues/Rules";

const AdHocSurveyForm = (props) => {
	const navigate = useNavigate();

	const [rules, setRuleValues] = useState([]);

	useEffect(() => {
		async function getRules() {
			const allRules = await getAllRulesAsync();
			setRuleValues(allRules);
		}
		getRules();
	}, []);

	const onCancel = () => {
		navigate("/adhoc-surveys");
	};

	const validationSchema = Yup.object().shape({
		name: Yup.string().required("Please enter a name"),
		alchemerId: Yup.string().required("Please enter an Alchemer ID"),
		emailTemplate: Yup.string().required("Please enter a Mandrill template slug"),
		sendSurveyOn: Yup.date().required("Please enter a send on date"),
		windowStartDate: Yup.date().required("Please enter a course start date window beginning"),
		windowEndDate: Yup.date().required("Please enter a course end date window end"),
		rules: Yup.array().of(Yup.string()).min(1, "Please enter rules"),
	});

	const { saveText, headerText, initialValues, onSubmit } = props;

	return (
		<div className="form-wrapper">
			<h4>{headerText}</h4>
			<Formik initialValues={initialValues} enableReinitialize="true" validationSchema={validationSchema} validateOnMount="true" onSubmit={onSubmit}>
				{({ isValid, values }) => (
					<Form>
						<Row>
							<FormGroup as={Col} className="form-group">
								<label htmlFor="name">Name</label>
								<Field id="name" name="name" type="text" className="form-control" />
								<ErrorMessage name="name" className="d-block invalid-feedback" component="span" />
							</FormGroup>
							<FormGroup as={Col} className="form-group">
								<label htmlFor="alchemerId">Alchemer ID</label>
								<Field id="alchemerId" name="alchemerId" type="text" className="form-control" />
								<ErrorMessage name="alchemerId" className="d-block invalid-feedback" component="span" />
							</FormGroup>
						</Row>
						<Row>
							<FormGroup as={Col} className="form-group">
								<label htmlFor="emailTemplate">Mandrill Template Slug</label>
								<Field id="emailTemplate" name="emailTemplate" type="text" className="form-control" />
								<ErrorMessage name="emailTemplate" className="d-block invalid-feedback" component="span" />
							</FormGroup>
							<FormGroup as={Col} className="form-group">
								<label htmlFor="sendSurveyOn">Send on</label>
								<Field id="sendSurveyOn" name="sendSurveyOn" type="date" className="form-control" />
								<ErrorMessage name="sendSurveyOn" className="d-block invalid-feedback" component="span" />
							</FormGroup>
						</Row>
						<Row>
							<FormGroup as={Col} className="form-group">
								<label htmlFor="windowStartDate">Course start date window begins on</label>
								<Field id="windowStartDate" name="windowStartDate" type="date" className="form-control" />
								<ErrorMessage name="windowStartDate" className="d-block invalid-feedback" component="span" />
							</FormGroup>
							<FormGroup as={Col} className="form-group">
								<label htmlFor="windowEndDate">Course start date window ends on</label>
								<Field id="windowEndDate" name="windowEndDate" type="date" className="form-control" />
								<ErrorMessage name="windowEndDate" className="d-block invalid-feedback" component="span" />
							</FormGroup>
						</Row>
						<FieldArray name="rules">
							{({ remove, push }) => (
								<div className="table-wrapper">
									<Button
										variant="primary"
										block="block"
										type="button"
										className="create-btn header-link"
										onClick={() => {
											push("");
										}}
									>
										Add rule
									</Button>
									<Table striped bordered hover>
										<thead>
											<tr>
												<th>Rule</th>
												<th>&nbsp;</th>
											</tr>
										</thead>
										<tbody>
											{!values.rules.length > 0 ? (
												<tr>
													<td colSpan={3}>
														<span className="d-block invalid-feedback">Please enter at least one rule</span>
													</td>
												</tr>
											) : (
												values.rules.map((rule, index) => (
													<tr key={index}>
														<td>
															<RulesSelect index={index} rules={rules} isNew={rule === ""} />
														</td>
														<td>
															<Button onClick={() => remove(index)} size="sm" variant="danger">
																Delete
															</Button>
														</td>
													</tr>
												))
											)}
										</tbody>
									</Table>
								</div>
							)}
						</FieldArray>
						<div className="form-submission">
							<Button variant="primary" block="block" type="submit" className="create-btn" disabled={!isValid}>
								{saveText}
							</Button>
							<Button variant="danger" block="block" type="button" onClick={onCancel}>
								Cancel
							</Button>
						</div>
					</Form>
				)}
			</Formik>
		</div>
	);
};
AdHocSurveyForm.propTypes = {
	saveText: PropTypes.string.isRequired,
	headerText: PropTypes.string.isRequired,
	initialValues: PropTypes.shape({
		name: PropTypes.string.isRequired,
		alchemerId: PropTypes.string.isRequired,
		emailTemplate: PropTypes.string.isRequired,
		sendSurveyOn: PropTypes.string.isRequired,
		windowStartDate: PropTypes.string.isRequired,
		windowEndDate: PropTypes.string.isRequired,
		rules: PropTypes.arrayOf(PropTypes.string),
	}).isRequired,
	onSubmit: PropTypes.func.isRequired,
};

export default AdHocSurveyForm;
